export default "__VITE_ASSET__53a3927f__"